import React from 'react'

const React_Coding_Practice_24 = () => {
  return (
    <div>
      <h1>Coding Pratice 24</h1>
    </div>
  )
}

export default React_Coding_Practice_24
